import React, { useState, useEffect } from 'react';
import { supabase } from './supabaseClient';
import imageCompression from 'browser-image-compression';
import './App.css';

function IconSpark() {
  return (
    <svg viewBox="0 0 24 24" width="30" height="30" fill="currentColor">
      <path d="M12 0 L14.2 9.8 L24 12 L14.2 14.2 L12 24 L9.8 14.2 L0 12 L9.8 9.8 Z" />
    </svg>
  );
}
function IconBasket() {
  return (
    <svg viewBox="0 0 24 24" width="28" height="28" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="M4 9 L8 3 L16 3 L20 9" />
      <rect x="3" y="9" width="18" height="11" rx="1.5" />
      <line x1="3" y1="13" x2="21" y2="13" />
    </svg>
  );
}
function IconFork() {
  return (
    <svg viewBox="0 0 24 24" width="26" height="26" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <line x1="7" y1="2" x2="7" y2="22" />
      <path d="M4 2 v8 M7 2 v8 M10 2 v8" />
      <path d="M17 2 c-3 0 -3 5 0 7 v13" />
    </svg>
  );
}
function IconPin() {
  return (
    <svg viewBox="0 0 24 24" width="26" height="26" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="M12 22 C12 22 19 14.5 19 9 A7 7 0 0 0 5 9 C5 14.5 12 22 12 22 Z" />
      <circle cx="12" cy="9" r="2.3" fill="currentColor" stroke="none" />
    </svg>
  );
}

const CATEGORIES = {
  events:   { label: 'Events',    Icon: IconSpark,  className: 'events' },
  markets:  { label: 'Markets',   Icon: IconBasket, className: 'markets' },
  foodfest: { label: 'Food Fest', Icon: IconFork,   className: 'foodfest' },
  explore:  { label: 'Explore',   Icon: IconPin,    className: 'explore' },
};

function todayStr() { const d = new Date(); return d.getFullYear() + '-' + String(d.getMonth()+1).padStart(2,'0') + '-' + String(d.getDate()).padStart(2,'0'); }
function dateStr(d) { return d.getFullYear() + '-' + String(d.getMonth()+1).padStart(2,'0') + '-' + String(d.getDate()).padStart(2,'0'); }
function greeting() { const h = new Date().getHours(); if (h < 12) return 'Good morning'; if (h < 18) return 'Good afternoon'; return 'Good evening'; }
function next7Days() { const days = []; for (let i = 0; i < 7; i++) { const d = new Date(); d.setDate(d.getDate() + i); days.push(d); } return days; }
function formatLongDate(dStr) { return new Date(dStr).toLocaleDateString('en-AU', { weekday: 'long', day: 'numeric', month: 'long' }); }

export default function App() {
  const [screen, setScreen] = useState('splash');
  const [activeTab, setActiveTab] = useState('home');
  const [selectedEvent, setSelectedEvent] = useState(null);
  const [selectedDate, setSelectedDate] = useState(dateStr(new Date()));
  const [activeCategory, setActiveCategory] = useState('events');
  const [userName, setUserName] = useState('');
  const [userId, setUserId] = useState('');
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(function() { fetchAll(); checkUser(); }, []);

  async function checkUser() {
    const result = await supabase.auth.getSession();
    const session = result.data.session;
    if (session) {
      setUserId(session.user.id);
      setUserName(session.user.user_metadata && session.user.user_metadata.full_name ? session.user.user_metadata.full_name : session.user.email.split('@')[0]);
      setScreen('home');
    }
  }

  async function fetchAll() {
    const e = await supabase.from('events').select('*').order('event_start', { ascending: true });
    if (!e.error) setEvents(e.data);
    setLoading(false);
  }

  function goHome() { setActiveTab('home'); setScreen('home'); }

  async function handleLogout() {
    await supabase.auth.signOut();
    setUserName(''); setUserId(''); setActiveTab('home'); setScreen('splash');
  }

  function openCategory(cat) {
    setActiveCategory(cat);
    if (cat === 'explore') setScreen('explore');
    else setScreen('feed');
  }

  function openDayFeed(dateString) {
    setSelectedDate(dateString);
    setScreen('feed');
  }

  const dayEvents = events.filter(function(e) {
    if (e.category === 'explore') return false;
    return e.event_start <= selectedDate && (!e.event_end || e.event_end >= selectedDate);
  });

  const dayEventsForCategory = screen === 'feed'
    ? dayEvents.filter(function(e) { return e.category === activeCategory || activeCategory === 'all'; })
    : dayEvents;

  if (screen === 'splash') return <Splash onStart={function() { setScreen('signup'); }} onLogin={function() { setScreen('login'); }} />;
  if (screen === 'login') return <Login onDone={function(id, name) { setUserId(id); setUserName(name); setScreen('home'); }} onBack={function() { setScreen('splash'); }} />;
  if (screen === 'signup') return <SignUp onDone={function(id, name) { setUserId(id); setUserName(name); setScreen('home'); }} onBack={function() { setScreen('splash'); }} />;

  if (screen === 'eventdetail') {
    return <EventDetail event={selectedEvent} onBack={function() { setScreen('feed'); }} onHome={goHome} userId={userId} userName={userName} />;
  }

  if (screen === 'feed') {
    return (
      <DailyFeed
        events={dayEventsForCategory}
        selectedDate={selectedDate}
        setSelectedDate={setSelectedDate}
        activeCategory={activeCategory}
        onSelectEvent={function(e) { setSelectedEvent(e); setScreen('eventdetail'); }}
        onHome={goHome}
        onEventAdded={fetchAll}
        userId={userId}
        userName={userName}
      />
    );
  }

  if (screen === 'explore') {
    const exploreItems = events.filter(function(e) { return e.category === 'explore'; });
    return (
      <Explore
        items={exploreItems}
        onSelectEvent={function(e) { setSelectedEvent(e); setScreen('eventdetail'); }}
        onHome={goHome}
        onEventAdded={fetchAll}
        userId={userId}
        userName={userName}
      />
    );
  }

  return (
    <div className="app">
      {activeTab === 'home' &&
        <div>
          <div className="home-header">
            <div className="greet">{greeting()}</div>
            <div className="subgreet">What's on today in Canberra?</div>
          </div>

          <div className="date-strip">
            {next7Days().map(function(d) {
              const ds = dateStr(d);
              const isToday = ds === todayStr();
              return (
                <div key={ds} className={'date-chip' + (isToday ? ' active' : '')} onClick={function() { openDayFeed(ds); }}>
                  {d.toLocaleDateString('en-AU', { weekday: 'short' })}
                  <span className="dnum">{d.getDate()}</span>
                </div>
              );
            })}
          </div>

          <div className="tile-grid">
            {Object.keys(CATEGORIES).map(function(key) {
              const cat = CATEGORIES[key];
              return (
                <div key={key} className={'category-tile ' + cat.className} onClick={function() { openCategory(key); }}>
                  <div className="tile-icon"><cat.Icon /></div>
                  <div className="tile-label">{cat.label}</div>
                </div>
              );
            })}
          </div>

          <div style={{ height: '40px' }}></div>
        </div>
      }

      {activeTab === 'saved' &&
        <div>
          <TopNav title="Saved" onHome={goHome} />
          <div className="empty-txt" style={{ padding: '60px 20px' }}>Nothing saved yet.</div>
        </div>
      }

      {activeTab === 'profile' &&
        <div>
          <TopNav title="Profile" onHome={goHome} />
          <div style={{ padding: '20px 0' }}>
            <div className="profile-card">
              <div className="profile-avatar">{userName ? userName[0].toUpperCase() : '?'}</div>
              <div className="profile-name">{userName || 'LocoPilot user'}</div>
            </div>
            <button className="logout-btn" onClick={handleLogout}>Log out</button>
          </div>
        </div>
      }

      <div className="bottom-nav">
        <div className={'nav-item ' + (activeTab === 'home' ? 'active' : '')} onClick={goHome}><span>⌂</span><span>Home</span></div>
        <div className={'nav-item ' + (activeTab === 'saved' ? 'active' : '')} onClick={function() { setActiveTab('saved'); setScreen('home'); }}><span>♡</span><span>Saved</span></div>
        <div className={'nav-item ' + (activeTab === 'profile' ? 'active' : '')} onClick={function() { setActiveTab('profile'); setScreen('home'); }}><span>◎</span><span>Profile</span></div>
      </div>
    </div>
  );
}

function TopNav(props) {
  return (
    <div className="top-nav">
      <button className="home-btn" onClick={props.onHome}>⌂ Home</button>
      <div className="top-nav-title">{props.title}</div>
    </div>
  );
}

function DailyFeed(props) {
  const days = next7Days();
  const [showAddForm, setShowAddForm] = useState(false);

  return (
    <div className="app">
      <div className="feed-header">
        <button className="feed-back" onClick={props.onHome}>←</button>
        <div className="feed-title">{formatLongDate(props.selectedDate)}</div>
      </div>

      <div className="date-strip">
        {days.map(function(d) {
          const ds = dateStr(d);
          return (
            <div key={ds} className={'date-chip' + (props.selectedDate === ds ? ' active' : '')} onClick={function() { props.setSelectedDate(ds); setShowAddForm(false); }}>
              {d.toLocaleDateString('en-AU', { weekday: 'short' })}
              <span className="dnum">{d.getDate()}</span>
            </div>
          );
        })}
      </div>

      <div className="feed-list">
        {props.events.length === 0 && <div className="empty-txt">Nothing scheduled this day.</div>}
        {props.events.map(function(e) {
          const cat = CATEGORIES[e.category] || CATEGORIES.events;
          return (
            <div key={e.id} className={'feed-card ' + cat.className} onClick={function() { props.onSelectEvent(e); }}>
              <div className="feed-icon-circle"><cat.Icon /></div>
              <div className="feed-info">
                <div className="feed-name">{e.title}</div>
                <div className="feed-meta">{e.event_time || 'All day'} · {e.suburb}</div>
              </div>
              {e.photo && <img className="feed-thumb" src={e.photo} alt={e.title} />}
            </div>
          );
        })}
      </div>

      <div style={{ padding: '16px 20px' }}>
        {!showAddForm ? (
          <button className="btn-ghost" onClick={function() {
            if (!props.userId) { alert('Please log in to add an event'); return; }
            setShowAddForm(true);
          }}>+ Add an event on this day</button>
        ) : (
          <AddEventInline
            date={props.selectedDate}
            defaultCategory={props.activeCategory}
            userId={props.userId}
            userName={props.userName}
            onDone={function() { setShowAddForm(false); props.onEventAdded(); }}
            onCancel={function() { setShowAddForm(false); }}
          />
        )}
      </div>

      <div style={{ height: '40px' }}></div>
      <div className="bottom-nav">
        <div className="nav-item active" onClick={props.onHome}><span>⌂</span><span>Home</span></div>
        <div className="nav-item"><span>♡</span><span>Saved</span></div>
        <div className="nav-item"><span>◎</span><span>Profile</span></div>
      </div>
    </div>
  );
}

function AddEventInline(props) {
  const [title, setTitle] = useState('');
  const [description, setDescription] = useState('');
  const [category, setCategory] = useState(props.defaultCategory && props.defaultCategory !== 'explore' ? props.defaultCategory : 'events');
  const [eventTime, setEventTime] = useState('');
  const [suburb, setSuburb] = useState('');
  const [error, setError] = useState('');
  const [saving, setSaving] = useState(false);

  async function handleSubmit() {
    setError('');
    if (!title || !suburb) { setError('Please fill in event name and suburb'); return; }
    if (!props.userId) { setError('Please log in to add an event'); return; }
    setSaving(true);
    const result = await supabase.from('events').insert({
      title: title,
      description: description || title,
      category: category,
      event_start: props.date,
      event_end: props.date,
      event_time: eventTime || null,
      suburb: suburb,
      added_by: props.userName,
      user_id: props.userId
    });
    setSaving(false);
    if (result.error) setError('Could not save: ' + result.error.message);
    else props.onDone();
  }

  return (
    <div className="comment-box">
      <div className="section-label" style={{ marginTop: 0 }}>Add a new event</div>
      <div className="subtab-row" style={{ padding: '0 0 12px' }}>
        {['events', 'markets', 'foodfest'].map(function(key) {
          const c = CATEGORIES[key];
          return (
            <div key={key} className={'subtab' + (category === key ? ' active' : '')} onClick={function() { setCategory(key); }}>
              {c.label}
            </div>
          );
        })}
      </div>
      <input className="auth-input" placeholder="Event name" value={title} onChange={function(e) { setTitle(e.target.value); }} style={{ marginBottom: '8px' }} />
      <input className="auth-input" placeholder="Time (e.g. 9:00 AM)" value={eventTime} onChange={function(e) { setEventTime(e.target.value); }} style={{ marginBottom: '8px' }} />
      <input className="auth-input" placeholder="Suburb / location" value={suburb} onChange={function(e) { setSuburb(e.target.value); }} style={{ marginBottom: '8px' }} />
      <textarea className="auth-input" placeholder="Description" value={description} onChange={function(e) { setDescription(e.target.value); }} style={{ minHeight: '60px', marginBottom: '8px' }} />
      {error && <div className="auth-error" style={{ marginBottom: '8px' }}>{error}</div>}
      <div style={{ display: 'flex', gap: '8px' }}>
        <button className="btn-gold" onClick={handleSubmit} disabled={saving}>{saving ? 'Adding...' : 'Add event'}</button>
        <button className="btn-ghost" onClick={props.onCancel}>Cancel</button>
      </div>
    </div>
  );
}

function Explore(props) {
  const [subtab, setSubtab] = useState('mustsee');
  const [showAddForm, setShowAddForm] = useState(false);
  const filtered = props.items.filter(function(e) { return (e.subcategory || 'mustsee') === subtab; });

  return (
    <div className="app">
      <div className="feed-header">
        <button className="feed-back" onClick={props.onHome}>←</button>
        <div className="feed-title">Explore</div>
      </div>

      <div className="subtab-row">
        <div className={'subtab' + (subtab === 'mustsee' ? ' active' : '')} onClick={function() { setSubtab('mustsee'); setShowAddForm(false); }}>Must-See</div>
        <div className={'subtab' + (subtab === 'indoor' ? ' active' : '')} onClick={function() { setSubtab('indoor'); setShowAddForm(false); }}>Indoor</div>
        <div className={'subtab' + (subtab === 'nature' ? ' active' : '')} onClick={function() { setSubtab('nature'); setShowAddForm(false); }}>Nature</div>
      </div>

      <div className="feed-list">
        {filtered.length === 0 && <div className="empty-txt">Nothing here yet.</div>}
        {filtered.map(function(e) {
          return (
            <div key={e.id} className="feed-card explore" onClick={function() { props.onSelectEvent(e); }}>
              <div className="feed-icon-circle"><IconPin /></div>
              <div className="feed-info">
                <div className="feed-name">{e.title}</div>
                <div className="feed-meta">{e.suburb}</div>
              </div>
              {e.photo && <img className="feed-thumb" src={e.photo} alt={e.title} />}
            </div>
          );
        })}
      </div>

      <div style={{ padding: '16px 20px' }}>
        {!showAddForm ? (
          <button className="btn-ghost" onClick={function() {
            if (!props.userId) { alert('Please log in to add a spot'); return; }
            setShowAddForm(true);
          }}>+ Add a spot</button>
        ) : (
          <AddExploreInline
            subcategory={subtab}
            userId={props.userId}
            userName={props.userName}
            onDone={function() { setShowAddForm(false); props.onEventAdded(); }}
            onCancel={function() { setShowAddForm(false); }}
          />
        )}
      </div>

      <div style={{ height: '40px' }}></div>
      <div className="bottom-nav">
        <div className="nav-item active" onClick={props.onHome}><span>⌂</span><span>Home</span></div>
        <div className="nav-item"><span>♡</span><span>Saved</span></div>
        <div className="nav-item"><span>◎</span><span>Profile</span></div>
      </div>
    </div>
  );
}

function AddExploreInline(props) {
  const [title, setTitle] = useState('');
  const [description, setDescription] = useState('');
  const [suburb, setSuburb] = useState('');
  const [error, setError] = useState('');
  const [saving, setSaving] = useState(false);

  async function handleSubmit() {
    setError('');
    if (!title || !suburb) { setError('Please fill in name and suburb'); return; }
    if (!props.userId) { setError('Please log in to add a spot'); return; }
    setSaving(true);
    const result = await supabase.from('events').insert({
      title: title,
      description: description || title,
      category: 'explore',
      subcategory: props.subcategory,
      suburb: suburb,
      added_by: props.userName,
      user_id: props.userId
    });
    setSaving(false);
    if (result.error) setError('Could not save: ' + result.error.message);
    else props.onDone();
  }

  return (
    <div className="comment-box">
      <div className="section-label" style={{ marginTop: 0 }}>Add a spot</div>
      <input className="auth-input" placeholder="Place name" value={title} onChange={function(e) { setTitle(e.target.value); }} style={{ marginBottom: '8px' }} />
      <input className="auth-input" placeholder="Suburb / location" value={suburb} onChange={function(e) { setSuburb(e.target.value); }} style={{ marginBottom: '8px' }} />
      <textarea className="auth-input" placeholder="Description" value={description} onChange={function(e) { setDescription(e.target.value); }} style={{ minHeight: '60px', marginBottom: '8px' }} />
      {error && <div className="auth-error" style={{ marginBottom: '8px' }}>{error}</div>}
      <div style={{ display: 'flex', gap: '8px' }}>
        <button className="btn-gold" onClick={handleSubmit} disabled={saving}>{saving ? 'Adding...' : 'Add spot'}</button>
        <button className="btn-ghost" onClick={props.onCancel}>Cancel</button>
      </div>
    </div>
  );
}

function EventDetail(props) {
  const e = props.event;
  const [sections, setSections] = useState([]);
  const [comments, setComments] = useState([]);
  const [newComment, setNewComment] = useState('');
  const [activeCommentSection, setActiveCommentSection] = useState(null);
  const [addingPhoto, setAddingPhoto] = useState(false);

  useEffect(function() { if (e) fetchData(); }, [e]);

  async function fetchData() {
    const result = await supabase.from('event_sections').select('*').eq('event_id', e.id).order('likes', { ascending: false });
    if (!result.error) setSections(result.data);
  }

  async function fetchComments() {
    const result = await supabase.from('event_photo_comments').select('*').order('created_at', { ascending: true });
    if (!result.error) setComments(result.data.filter(function(c) { return sections.some(function(s) { return s.id === c.section_id; }); }));
  }

  useEffect(function() { if (sections.length > 0) fetchComments(); }, [sections]);

  async function handleUploadPhoto(ev) {
    const file = ev.target.files[0];
    if (!file) return;
    if (!props.userId) { alert('Please log in to add a photo'); return; }
    setAddingPhoto(true);
    try {
      const options = { maxSizeMB: 0.3, maxWidthOrHeight: 1200, useWebWorker: true };
      const compressed = await imageCompression(file, options);
      const fileName = Date.now() + '-event.jpg';
      const upload = await supabase.storage.from('listing-photos').upload(fileName, compressed);
      if (upload.error) { alert('Upload failed: ' + upload.error.message); setAddingPhoto(false); return; }
      const url = supabase.storage.from('listing-photos').getPublicUrl(fileName);
      await supabase.from('event_sections').insert({ event_id: e.id, photo_url: url.data.publicUrl, added_by: props.userName, user_id: props.userId, likes: 0 });
      fetchData();
    } catch (err) { alert('Could not process image'); }
    setAddingPhoto(false);
  }

  async function handleUpvote(id, likes) {
    await supabase.from('event_sections').update({ likes: likes + 1 }).eq('id', id);
    fetchData();
  }

  async function handleAddComment(sectionId) {
    if (!newComment.trim() || !props.userId) return;
    await supabase.from('event_photo_comments').insert({ section_id: sectionId, comment_text: newComment, added_by: props.userName, user_id: props.userId });
    setNewComment('');
    fetchComments();
  }

  if (!e) return null;
  const cat = CATEGORIES[e.category] || CATEGORIES.events;

  return (
    <div className="detail-page">
      <div className="detail-hero">
        <button className="detail-back" onClick={props.onBack}>←</button>
        {e.photo && <img src={e.photo} alt={e.title} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />}
      </div>
      <div className="detail-body">
        <div className="detail-name">{e.title}</div>
        <div className="detail-sub">
          {e.event_start ? formatLongDate(e.event_start) : ''}
          {e.event_time ? ' · ' + e.event_time : ''}
          {e.suburb ? ' · 📍 ' + e.suburb : ''}
        </div>

        <div className="section-label">📷 Community Photos</div>
        {sections.length > 0 ? (
          <div className="photo-grid">
            {sections.map(function(s) {
              return (
                <div key={s.id} className="photo-grid-item" onClick={function() { setActiveCommentSection(s.id); }}>
                  <img src={s.photo_url} alt="Community" />
                  <button className="photo-like-btn" onClick={function(ev) { ev.stopPropagation(); handleUpvote(s.id, s.likes); }}>❤️ {s.likes || 0}</button>
                </div>
              );
            })}
          </div>
        ) : (
          <div className="empty-txt" style={{ padding: '10px 0' }}>No photos yet — be the first.</div>
        )}

        <label>
          <div className="upload-box">{addingPhoto ? 'Uploading...' : '📷 Add your photo'}</div>
          <input type="file" accept="image/*" onChange={handleUploadPhoto} style={{ display: 'none' }} disabled={addingPhoto} />
        </label>

        <div className="section-label">💬 Comments</div>
        <div className="comment-box">
          {comments.length === 0 && <div className="comment-row" style={{ color: '#8a8a80' }}>No comments yet.</div>}
          {comments.map(function(c) {
            return <div key={c.id} className="comment-row">"{c.comment_text}" — <b>{c.added_by}</b></div>;
          })}
          <div className="comment-input-row">
            <input
              className="comment-input"
              placeholder="Add a comment..."
              value={newComment}
              onChange={function(ev) { setNewComment(ev.target.value); }}
            />
            <button
              className="comment-post-btn"
              onClick={function() {
                const targetSection = activeCommentSection || (sections[0] && sections[0].id);
                if (targetSection) handleAddComment(targetSection);
              }}
            >
              Post
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

function Splash(props) {
  return (
    <div className="splash">
      <div className="splash-center">
        <div className="splash-mark">LP</div>
        <div className="splash-name">Loco<span>Pilot</span></div>
        <div className="splash-tag">What's happening near you, today — Canberra</div>
      </div>
      <div className="splash-actions">
        <button className="btn-gold" onClick={props.onStart}>Get started — it's free</button>
        <button className="btn-ghost" onClick={props.onLogin}>I already have an account</button>
      </div>
    </div>
  );
}

function Login(props) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  async function handleLogin() {
    setError('');
    if (!email || !password) { setError('Please enter email and password'); return; }
    setLoading(true);
    const result = await supabase.auth.signInWithPassword({ email: email, password: password });
    setLoading(false);
    if (result.error) { setError(result.error.message); }
    else {
      const u = result.data.user;
      const name = u.user_metadata && u.user_metadata.full_name ? u.user_metadata.full_name : u.email.split('@')[0];
      props.onDone(u.id, name);
    }
  }
  return (
    <div className="auth">
      <div className="auth-top">
        <div className="auth-logo">Loco<span>Pilot</span></div>
        <div className="auth-title">Welcome back</div>
      </div>
      <div className="auth-card">
        {error && <div className="auth-error">{error}</div>}
        <input className="auth-input" placeholder="Email address" type="email" value={email} onChange={function(e) { setEmail(e.target.value); }} />
        <input className="auth-input" placeholder="Password" type="password" value={password} onChange={function(e) { setPassword(e.target.value); }} />
        <button className="btn-gold" onClick={handleLogin} disabled={loading}>{loading ? 'Logging in...' : 'Log in'}</button>
        <button className="btn-ghost" onClick={props.onBack}>Back</button>
      </div>
    </div>
  );
}

function SignUp(props) {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  async function handleSignUp() {
    setError('');
    if (!name || !email || !password) { setError('Please fill in all fields'); return; }
    if (password.length < 6) { setError('Password must be at least 6 characters'); return; }
    setLoading(true);
    const result = await supabase.auth.signUp({ email: email, password: password, options: { data: { full_name: name } } });
    setLoading(false);
    if (result.error) { setError(result.error.message); return; }
    const u = result.data.user;
    if (u && u.identities && u.identities.length === 0) { setError('An account with this email already exists. Please log in instead.'); return; }
    props.onDone(u ? u.id : '', name);
  }
  return (
    <div className="auth">
      <div className="auth-top">
        <div className="auth-logo">Loco<span>Pilot</span></div>
        <div className="auth-title">Create your account</div>
      </div>
      <div className="auth-card">
        {error && <div className="auth-error">{error}</div>}
        <input className="auth-input" placeholder="Display name" value={name} onChange={function(e) { setName(e.target.value); }} />
        <input className="auth-input" placeholder="Email address" type="email" value={email} onChange={function(e) { setEmail(e.target.value); }} />
        <input className="auth-input" placeholder="Password" type="password" value={password} onChange={function(e) { setPassword(e.target.value); }} />
        <button className="btn-gold" onClick={handleSignUp} disabled={loading}>{loading ? 'Creating account...' : 'Create account'}</button>
        <button className="btn-ghost" onClick={props.onBack}>Back</button>
      </div>
    </div>
  );
}